import filterPageContentBlocks from './filterPageContentBlocks';
import { isQuestionBlock } from './questionNumberingUtils';

export const getQuestionBlockIds = blocks => {
  return filterPageContentBlocks(blocks)
    .filter(isQuestionBlock)
    .map(question => question.id);
};
